export { default } from './SensaiStarter'
